import React from "react";

import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Button } from "@mui/material";

type Props = React.ComponentProps<typeof Button>;

const EditIconButton: React.FC<Props> = (props) => {
  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<EditRoundedIcon fontSize="small" />}
      {...props}
    >
      Edit
    </Button>
  );
};

export default EditIconButton;
